import { get, set, del } from 'utils/LocalStorageUtil';
import { setNewRelicParam } from './Metrics';
const HKS_KEY = 'PHPSESSID';

export const removeHKS = () => {
  del(HKS_KEY);
};

export const setHKS = value => {
  set(HKS_KEY, value);
  //setNewRelicParam({ HKS: value });
};

export const getHKS = () => get(HKS_KEY);
